const styles = (theme) => ({
	containerApi: {
		width: "100%", // Ocupa todo o espaço disponível
		display: "flex",
		flexDirection: "column",
		gap: 2,
		justifyContent: "flex-end",
		pb: 1,
	},
	containerAnaliseApi: {
		display: "flex",
		flexDirection: "row",
		gap: "3px",
		justifyContent: "center",
		width: "100%", // Ocupa todo o espaço disponível
	},
	containerDia: {
		height: "60px", //36
		width: "5px",
		// "&:hover": {
		//   transform: "scaleY(1.01)",
		//   transition: "transform 0.3s ease-in-out",
		// },
	},
	containerAnaliseDias: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		gap: "8px",
		width: "100%", // Ocupa todo o espaço disponível
	},
	containerDivider: {
		width: "100%",
	},
	containerHoje: {
		minWidth: "100px",
	},
	containerData: {
		marginBottom: "5px",
	},
	containerRequisicao: {
		display: "flex",
		alignItems: "center",
	},
	containerFalha: {
		display: "flex",
		alignItems: "center",
	},
	containerSemDados: {
		marginBottom: "5px",
	},
	tooltipStyles: {
		tooltip: {
			sx: {
				bgcolor: theme.palette.paletteCharts.lineCharts,
				color: theme.palette.text.main,
				padding: "8px",
				borderRadius: "8px",
				boxShadow: `0 4px 8px ${theme.palette.colors.black.darker}4D`,
				maxWidth: "300px", // Limite máximo para o tooltip
			},
		},
		arrow: {
			sx: {
				color: theme.palette.paletteCharts.lineCharts,
			},
		},
	},
	containerStatusRequisicao: {
		bgcolor: theme.palette.status.apiPalette.request,
		width: "10px",
		height: "10px",
		borderRadius: "10px",
		marginRight: "5px",
	},
	containerStatusFalha: {
		bgcolor: theme.palette.status.apiPalette.error,
		width: "10px",
		height: "10px",
		borderRadius: "10px",
		marginRight: "5px",
	},
	tituloData: {
		fontSize: "13px",
		fontWeight: "600",
	},
	tituloRequisicao: {
		fontSize: "13px",
	},
	tituloDias: {
		fontSize: "12px",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
});

export default styles;
